module.exports = __webpack_public_path__ + "img/3.4b389a9e.png";